import React from 'react';
import CollapsibleVideos from './CollapsibleVideos';
import { useSelector } from 'react-redux';
import { FaCamera } from 'react-icons/fa';
import EmptyContent from '../../EmptyContent';

function VideosTab() {
  const { segments } = useSelector((state) => state?.hotbar);

  // Calculate the total number of valid videos
  const totalVideos = segments?.reduce((sum, segment) => {
    return sum + (segment?.items?.videos?.filter((video) => video?.src !== null).length || 0);
  }, 0);

  return (
    <>
      {totalVideos > 0 ? (
        segments?.map((segment) =>
          segment?.items?.videos?.length ? (
            <CollapsibleVideos
              key={segment.title} // Assuming title is unique
              videos={segment.items.videos.filter((video) => video?.src !== null)}
              icon={<FaCamera />}
              title={segment.title}
              segmentColor={segment.segmentColor}
            />
          ) : null
        )
      ) : (
        <EmptyContent />
      )}
    </>
  );
}

export default VideosTab;
